import script from "./TimeView.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeView.vue?vue&type=script&setup=true&lang=js"

import "./TimeView.vue?vue&type=style&index=0&id=1aa61c90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa61c90"]])

export default __exports__